
import { Box } from "@mui/material";

import { TextareaAutosize } from "@mui/material";
import { useTheme } from "@emotion/react";

import { setupManagementUrl } from "../../../config";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";

import { DiscountTypesQuery} from "../../../data/Axios/queries";
import DiscountTypeForm from "./Form";

//const base_url = setupManagementUrl.uri;
const base_url = setupManagementUrl.uri
const actions = {
  entity: "Discount Types",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: true,
    permission: "ActivatePermission",
    modelName: "discounttypeIds",
    inputObjectName: "bulkActivateDeactivateDiscountTypes",
  },
  AssignTask: {
    key: "ASSIGN_TASK",
    button_name: "Assign Task",
    Show_Button: false,
    permission: "hasNoPermission",
    roleGroupId: [1, 2],
  },
  showStatus:true,
};
function DiscountTypesTable() {
const ignore =[""]
  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="Discount Types"
          subtitle="Manage Discount Types"
          //ignoreFields={ignore}
          FormComponent={DiscountTypeForm}
          query={DiscountTypesQuery}
          base_url={base_url}
          actions={actions}
        />
      </>
    </Box>
  );
}

export default DiscountTypesTable;
